(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tabs-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ct-collection-slider')) {
  customElements.define('ct-collection-slider', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.buttons = Array.from(this.querySelectorAll('[data-tab-button]'));
        this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
        this.viewAll = this.querySelector('[data-view-all]');
        this.carousels = this.panels.map(panel => {
          const track = panel.querySelector('[data-track]');
          const prev = panel.querySelector('[data-prev]');
          const next = panel.querySelector('[data-next]');
          const update = () => {
            if (panel.hidden) return;
            const max = Math.max(0, track.scrollWidth - track.clientWidth);
            prev.disabled = track.scrollLeft <= 2;
            next.disabled = track.scrollLeft >= max - 2;
          };
          const positions = () => {
            const origin = track.getBoundingClientRect().left;
            return Array.from(track.children).map(card =>
              card.getBoundingClientRect().left - origin + track.scrollLeft
            );
          };
          const move = direction => {
            const current = track.scrollLeft;
            const stops = positions();
            const target = direction > 0
              ? stops.find(position => position > current + 3)
              : stops.reverse().find(position => position < current - 3);
            const max = Math.max(0, track.scrollWidth - track.clientWidth);
            track.scrollTo({
              left: Math.min(max, Math.max(0, target ?? (direction > 0 ? max : 0))),
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
          };
          prev.addEventListener('click', () => move(-1), { signal });
          next.addEventListener('click', () => move(1), { signal });
          track.addEventListener('scroll', update, { passive: true, signal });
          track.addEventListener('keydown', event => {
            if (event.target !== track) return;
            if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
              event.preventDefault();
              move(event.key === 'ArrowRight' ? 1 : -1);
            }
          }, { signal });
          let drag = null;
          let suppressClick = false;
          track.addEventListener('dragstart', event => event.preventDefault(), { signal });
          track.addEventListener('pointerdown', event => {
            if (event.pointerType !== 'mouse' || event.button !== 0) return;
            suppressClick = false;
            drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: track.scrollLeft, moved: false };
          }, { signal });
          window.addEventListener('pointermove', event => {
            if (!drag || event.pointerId !== drag.id) return;
            const dx = event.clientX - drag.x;
            if (!drag.moved && Math.abs(dx) < 6) return;
            if (!drag.moved && Math.abs(event.clientY - drag.y) > Math.abs(dx)) {
              drag = null;
              return;
            }
            drag.moved = true;
            suppressClick = true;
            track.classList.add('is-dragging');
            event.preventDefault();
            track.scrollLeft = drag.left - dx;
          }, { signal, passive: false });
          const finishDrag = event => {
            if (!drag || event.pointerId !== drag.id) return;
            const moved = drag.moved;
            drag = null;
            track.classList.remove('is-dragging');
            if (moved) {
              const nearest = positions().reduce((best, position) =>
                Math.abs(position - track.scrollLeft) < Math.abs(best - track.scrollLeft) ? position : best, 0);
              track.scrollTo({ left: nearest, behavior: 'auto' });
              setTimeout(() => { suppressClick = false; }, 100);
            }
            update();
          };
          window.addEventListener('pointerup', finishDrag, { signal });
          window.addEventListener('pointercancel', finishDrag, { signal });
          track.addEventListener('click', event => {
            if (!suppressClick) return;
            event.preventDefault();
            event.stopPropagation();
          }, { capture: true, signal });
          return { track, update };
        });
        this.buttons.forEach((button, index) => {
          button.addEventListener('click', () => this.activate(button.dataset.tabButton), { signal });
          button.addEventListener('keydown', event => {
            let target;
            if (event.key === 'ArrowRight') target = (index + 1) % this.buttons.length;
            if (event.key === 'ArrowLeft') target = (index - 1 + this.buttons.length) % this.buttons.length;
            if (event.key === 'Home') target = 0;
            if (event.key === 'End') target = this.buttons.length - 1;
            if (target === undefined) return;
            event.preventDefault();
            const selected = this.buttons[target];
            this.activate(selected.dataset.tabButton);
            selected.focus({ preventScroll: true });
            const tabs = selected.parentElement;
            tabs.scrollLeft += selected.getBoundingClientRect().left - tabs.getBoundingClientRect().left;
          }, { signal });
        });
        document.addEventListener('shopify:block:select', event => {
          if (this.buttons.some(button => button.dataset.tabButton === event.detail.blockId)) {
            this.activate(event.detail.blockId);
          }
        }, { signal });
        this.observer = new ResizeObserver(() => this.carousels.forEach(item => item.update()));
        this.carousels.forEach(item => this.observer.observe(item.track));
        if (this.buttons.length) this.activate(this.buttons[0].dataset.tabButton);
        else if (this.viewAll) this.viewAll.hidden = true;
      });
    }
    activate(id) {
      this.buttons.forEach(button => {
        const active = button.dataset.tabButton === id;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
        button.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => {
        const active = panel.dataset.tabPanel === id;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      const selected = this.buttons.find(button => button.dataset.tabButton === id);
      if (this.viewAll) {
        const url = selected?.dataset.viewUrl;
        this.viewAll.hidden = !url;
        if (url) this.viewAll.href = url;
        else this.viewAll.removeAttribute('href');
      }
      this.carousels.forEach(item => item.update());
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__productTabsSectionBound) return;
    window.__productTabsSectionBound = true;

    function renderVideo(scope) {
      const root = scope || document;
      root.querySelectorAll('.video-open-popup:not([data-video-bound])').forEach((videoOpenPopup) => {
        videoOpenPopup.dataset.videoBound = 'true';
        videoOpenPopup.addEventListener('click', function (e) {
          e.preventDefault();
          const videoId = videoOpenPopup.dataset.videoId;
          const videoWrapper = document.querySelector('.video-modal__content-block');
          if (!videoWrapper || !videoId) return;
          videoWrapper.innerHTML = `<iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
        });
      });
    }

    function ensureVideoModal() {
      if (document.getElementById('PopupModal-product-tabs-video')) return;
      document.body.insertAdjacentHTML(
        'beforeend',
        `<side-drawer class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden" id="PopupModal-product-tabs-video" data-moved="true">
          <div class="drawer__overlay fixed inset-0 cursor-pointer"></div>
          <div class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup">
            <div class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar">
              <div class="video-modal__content-block">Video</div>
              <button onclick="this.closest('side-drawer').close()" class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute" type="button" aria-label="Close dialog" style="--top: 0.3rem; --right: 0.3rem">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg>
              </button>
            </div>
          </div>
        </side-drawer>`
      );
    }

    function openAccordionTab(tabContent) {
      const section = tabContent.closest('.section-product-tabs');
      if (!section) return;
      section.querySelectorAll('.style-accordion .toggle-title.is-open').forEach((el) => el.classList.remove('is-open'));
      tabContent.querySelector('.toggle-title')?.classList.add('is-open');
    }

    function closeAccordionTab(tabContent) {
      tabContent.querySelector('.toggle-title')?.classList.remove('is-open');
    }

    document.addEventListener('click', function (e) {
      const section = e.target.closest('.section-product-tabs');
      if (!section) return;

      const tabTitle = e.target.closest('.tab-title');
      if (tabTitle && section.contains(tabTitle)) {
        e.preventDefault();
        const tabList = section.querySelector('.tabs-list');
        if (!tabList) return;
        const tabTitles = [...tabList.querySelectorAll('.tab-title')];
        const tabContents = [...section.querySelectorAll('.product-tabs-tab .tabs-content > .tab-content')];
        const index = tabTitles.indexOf(tabTitle);
        if (index === -1 || tabTitle.classList.contains('is-active')) return;
        tabTitles.forEach((t) => t.classList.remove('is-active'));
        tabContents.forEach((c) => c.classList.remove('is-active'));
        tabTitle.classList.add('is-active');
        setTimeout(() => {
          const content = tabContents[index];
          if (!content) return;
          content.classList.add('is-animating', 'is-active');
          content.addEventListener(
            'transitionend',
            function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            },
            { once: true }
          );
        }, 10);
        return;
      }

      const toggleLink = e.target.closest('.toggle-link');
      if (!toggleLink || !section.contains(toggleLink)) return;
      e.preventDefault();

      const toggleTitle = toggleLink.closest('.toggle-title');
      if (!toggleTitle) return;

      const tabTitleText = document.querySelector('.tab-title-text');
      if (tabTitleText) tabTitleText.textContent = toggleLink.textContent;

      const viewContentType = toggleTitle.dataset.viewContent;
      const content = toggleTitle.nextElementSibling;
      if (!content) return;

      if (Shopify?.designMode && section.querySelector('.style-accordion')) return;

      switch (viewContentType) {
        case 'sidebar': {
          const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
          if (drawerContent) {
            drawerContent.innerHTML = '';
            drawerContent.appendChild(content.cloneNode(true));
            renderVideo(drawerContent);
          }
          break;
        }
        case 'popup': {
          const popupContent = document.querySelector('.popup-content-wrapper');
          if (popupContent) {
            popupContent.innerHTML = '';
            popupContent.appendChild(content.cloneNode(true));
            renderVideo(popupContent);
          }
          break;
        }
        default:
          toggleTitle.classList.toggle('is-open');
      }
    });

    if (Shopify?.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        openAccordionTab(tabContent);
      });

      document.addEventListener('shopify:block:deselect', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        closeAccordionTab(tabContent);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      ensureVideoModal();
      renderVideo();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valora-product-page-recommendations"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag = 'valora-pdp-recommendations';
  if (customElements.get(tag)) return;
  customElements.define(tag, class extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.init());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      cancelAnimationFrame(this.alignFrame);
      this.controller?.abort();
      this.observer?.disconnect();
      this.initialized = false;
    }
    init() {
      if (this.initialized || !this.isConnected) return;
      this.initialized = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.results = this.querySelector('[data-vpr-results]');
      if (!this.results) return;
      this.addEventListener('load', () => this.schedule(), { signal, capture: true });
      window.addEventListener('resize', () => this.schedule(), { signal, passive: true });
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          if (width !== this.lastWidth) { this.lastWidth = width; this.schedule(); }
        });
        this.observer.observe(this);
      }
      if (document.fonts) {
        document.fonts.ready.then(() => { if (!signal.aborted) this.schedule(); });
        document.fonts.addEventListener('loadingdone', () => this.schedule(), { signal });
      }
      this.schedule();
      if (this.dataset.fetch === 'true' && this.dataset.productId) this.loadProducts(signal);
      else this.finishEmpty();
    }
    async loadProducts(signal) {
      this.results.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(this.dataset.endpoint, window.location.origin);
        url.searchParams.set('product_id', this.dataset.productId);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('limit', this.dataset.limit);
        url.searchParams.set('intent', 'related');
        const response = await fetch(url, { signal });
        if (!response.ok) throw new Error('Recommendations request failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (signal.aborted) return;
        const replacement = html.getElementById(this.id)?.querySelector('[data-vpr-results]');
        if (replacement?.querySelector('.vpr__card')) this.results.innerHTML = replacement.innerHTML;
        this.dataset.fetch = 'false';
      } catch (error) {
        if (signal.aborted) return;
        // Keep the selected fallback collection if recommendations cannot load.
      }
      if (signal.aborted) return;
      this.results.removeAttribute('aria-busy');
      this.results.querySelector('.vpr__loading')?.remove();
      this.finishEmpty();
      this.schedule();
    }
    finishEmpty() {
      if (this.querySelector('.vpr__card')) { this.hidden = false; return; }
      if (this.dataset.editor === 'true') {
        if (!this.results.querySelector('.vpr__empty')) {
          const note = document.createElement('p');
          note.className = 'vpr__empty';
          note.textContent = '暂无推荐商品。请在区块设置中手动选择商品，或选择备用商品系列。';
          this.results.append(note);
        }
      } else this.hidden = true;
    }
    schedule() {
      cancelAnimationFrame(this.alignFrame);
      this.alignFrame = requestAnimationFrame(() => this.alignPrices());
    }
    alignPrices() {
      if (!this.isConnected) return;
      const cards = [...this.querySelectorAll('.vpr__card')];
      const rows = [];
      cards.forEach(card => card.querySelector('.vpr__title').style.removeProperty('--vpr-aligned-title'));
      cards.forEach(card => {
        const bounds = card.getBoundingClientRect();
        if (!bounds.width) return;
        const title = card.querySelector('.vpr__title');
        let row = rows.find(row => Math.abs(row.top - bounds.top) < 3);
        if (!row) { row = { top: bounds.top, items: [] }; rows.push(row); }
        row.items.push({ title, height: title.getBoundingClientRect().height });
      });
      rows.forEach(row => {
        const height = Math.max(...row.items.map(item => item.height));
        row.items.forEach(item => item.title.style.setProperty('--vpr-aligned-title', height + 'px'));
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
